import React from 'react';

export const defaultContext = '';

export const LocaleContext = React.createContext(defaultContext);
